import type { SYSAction } from "../../../../../../_ovlclient/src"
import type {
  HookFieldGetList_ReturnType,
  HookFieldGetList_Type,
  HookFormChanged_Type,
  HookLookupsRefresh_ReturnType,
} from "../../../../../../_ovlclient/src/global/hooks"
import { ScreenCurrent } from "../../../../../../_ovlclient/src/library/screenapi"

import { OfferingMainRefresh } from "../../screens/qutoffering/offering/helpers"
const HookLookupsRefresh: SYSAction<HookLookupsRefresh_ReturnType> = (
  _,
  { global }
) => {
  let state = global.getState()
  return {
    CardCode: state.ovl.features.SYSUserAdministration.lookups.CardCode,
  }
}
const HookField_CardCode_GetList: SYSAction<
  HookFieldGetList_Type,
  HookFieldGetList_ReturnType
> = (_, { global }) => {
  let state = global.getState()
  let cardCodeLookupState =
    state.ovl.features.SYSUserAdministration.lookups.CardCode
  let data = Object.keys(cardCodeLookupState.data).reduce((val, k) => {
    if (cardCodeLookupState.data[k].CardType === "C") {
      val[k] = cardCodeLookupState.data[k]
    }
    return val
  }, {})
  return { data, lookupDef: cardCodeLookupState.lookupDef }
}
const HookFormChanged: SYSAction<HookFormChanged_Type> = async (
  value,
  { global }
) => {
  let state = global.getState()
  let changedField = value.changedField
  if (
    changedField.field.fieldKey === "CardCode" &&
    changedField.validValueChanged
  ) {
    let screen = ScreenCurrent()
    if (screen.startsWith("QUT")) {
      await OfferingMainRefresh(state, undefined, screen)
    } else if (screen === "KPIAll") {
      await global
        .getActions()
        .app.features.KPI.actions.FetchAllKPIData({
          viewType: "All",
          filterCardCode: changedField.newValue,
        })
    }
  }
}

export let hooks = {
  HookLookupsRefresh,
  HookField_CardCode_GetList,
  HookFormChanged,
}
